module.exports = __webpack_public_path__ + "img/destination-store.75d7a626.png";